import React from 'react';
import styles from '../../styles/CierreCicloEscolarStyles/CierreCicloEscolar.module.css';

function ProgramsTable({ programs, onCerrarCiclo, currentPage, totalPages, onPageChange, loading }) {
  const getStatusBadgeClass = (estatus) => {
    if (estatus === 'CERRADO') return styles.statusCerrado;
    if (estatus === 'PARCIAL') return styles.statusParcial;
    return styles.statusAbierto;
  };

  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableSection}>
        <div className={styles.tableSectionHeader}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className={styles.tableSectionIcon}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z"/>
              </svg>
            </div>
            <h3 className={styles.tableSectionTitle}>Programas Académicos</h3>
          </div>
          <div className={styles.tablePagination}>
            <span className={styles.paginationInfo}>{currentPage} de {totalPages}</span>
            <div className={styles.paginationControls}>
              <button
                className={styles.paginationButton}
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage <= 1 || loading}
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M15 18l-6-6 6-6"/>
                </svg>
              </button>
              <button
                className={styles.paginationButton}
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage >= totalPages || loading}
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 18l6-6-6-6"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div className={styles.table}>
          <div className={styles.programsTableHeader}>
            <div className={styles.headerCell}>
              <span>Programa</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M7 10l5 5 5-5"/>
              </svg>
            </div>
            <div className={styles.headerCell}>
              <span>Estatus</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M7 10l5 5 5-5"/>
              </svg>
            </div>
            <div className={styles.headerCell}>Última Actualización</div>
            <div className={styles.headerCell}>Acciones</div>
          </div>

          <div className={styles.tableBody}>
            {loading ? (
              <div className={styles.programsTableRow}>
                <div className={styles.tableCell} style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '2rem' }}>
                  Cargando programas...
                </div>
              </div>
            ) : programs.length === 0 ? (
              <div className={styles.programsTableRow}>
                <div className={styles.tableCell} style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '2rem' }}>
                  No se encontraron programas con los filtros seleccionados.
                </div>
              </div>
            ) : (
              programs.map((program) => (
                <div key={program.id} className={styles.programsTableRow}>
                  <div className={styles.tableCell}>{program.nombre}</div>
                  <div className={styles.tableCell}>
                    <span className={`${styles.statusBadge} ${getStatusBadgeClass(program.estatus)}`}>
                      {program.estatus}
                    </span>
                  </div>
                  <div className={styles.tableCell}>{program.ultimaActualizacion}</div>
                  <div className={styles.tableCell}>
                    <button
                      className={styles.cerrarCicloButton}
                      onClick={() => onCerrarCiclo(program)}
                      disabled={program.estatus === 'CERRADO'}
                    >
                      CERRAR CICLO
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProgramsTable;
